// src/utils/salesReturn.js
import { currentDateTime, formatToUtc, getDateTimeFromSelectedDate } from "../lib/functions";
import dayjs from "dayjs";
import Big from "big.js";

// For calculating totals on returns
export const returnCalculateTotals = (dataSource = [], footerValues = {}) => {
  const totalSubtotal = dataSource.reduce((sum, item) => {
    const qty = new Big(item.return_quantity || 0);
    const rate = new Big(item.rate || 0);
    return sum.plus(qty.times(rate));
  }, new Big(0));

  const discountPercent = new Big(footerValues.discountPercent || 0);
  const taxPercent = new Big(footerValues.taxPercent || 0);
  const serviceCharge = new Big(footerValues.serviceCharge || 0);
  const paidAmount = new Big(footerValues.paidAmount || 0);

  const discountedAmount = totalSubtotal.minus(
    totalSubtotal.times(discountPercent).div(100)
  );

  const taxedAmount = discountedAmount.plus(
    discountedAmount.times(taxPercent).div(100)
  );

  const grandTotal = taxedAmount.plus(serviceCharge);

  const dueAmount = grandTotal.minus(paidAmount);

  return {
    totalSubtotal: Number(totalSubtotal.toFixed(2)),
    grandTotal: Number(grandTotal.toFixed(2)),
    dueAmount: Number(dueAmount.toFixed(2)),
  };
};

export const mapReturnItems = (itemList = []) => {
  return itemList?.map((item, index) => ({
    key: index + 1,
    warehouse_id: item.warehouse_id || 0,
    item_id: item.item_id,
    item_name: item.item_name || "",
    item_description: item.item_description || "",
    display_text: item.display_text || "",
    is_serial: item.is_serial || "no",
    available_qty: item.available_qty || item.item_qty || 0,
    base_unit_name: item.base_unit_name || null,
    conversion: item.conversion || 1,
    discount_acc_id: item.discount_acc_id || 0,
    discount_acc_name: item.discount_acc_name || "",
    item_discount: item.item_discount || 0,
    item_discount_per: item.item_discount_per || 0,
    item_qty: item.item_qty || 0, // original sold qty
    item_rate: Number(item.item_rate) || 0,
    item_return_rate: Number(item.item_return_rate || item.item_rate || 0),
    item_return_unit_price: Number(
      item.item_return_unit_price || item.item_rate || 0
    ),
    item_tax: item.item_tax || 0,
    item_tax_per: item.item_tax_per || 0,
    item_total: 0, // will be updated on qty change
    otherServiceTransactions: [],
    per_conversion: item.per_conversion || 1,
    per_symbol: item.per_symbol || "",
    per_unit_id: item.per_unit_id || null,
    per_unit_symbol: item.unit_symbol || "",
    purchase_average_rate: item?.purchase_average_rate || 0,
    qty_display: item.qty_display || "",
    retail_qty: 0,
    return_discount: item.return_discount || 0,
    sale_r_qty: 0, // return qty
    sale_r_rate: Number(item.item_rate || 0),
    selected_batch_id: item.selected_batch_id || null,
    serials: [],
    sold_qty: item.sold_qty || item.item_qty || 0,
    tax_acc_id: item.tax_acc_id || 0,
    tax_acc_name: item.tax_acc_name || "",
    unit_name: item.unit_name || "",
    unit_symbol: item.unit_symbol || "",
    units: item.units || [],
    updatedServiceAllocations: [],
    product: item.item_name || "",
    quantity: Number(item.item_qty) || 0,
    return_quantity: 0,
    rate: Number(item.item_return_unit_price) || 0,
    discount: 0,
    vat: 0,
    is_tatmeen_required: item?.is_tatmeen_required == true ||
      item?.is_tatmeen_required === 1 ||
      item?.is_tatmeen_required === "1"
      ? true
      : false,
  }));
};

// Map payments for returns
// export const mapReturnPayCart = (payCart) => {
//   return payCart?.map((el) => ({
//     to_acc_id: 62,
//     acc_type_id: "cash_in_hand",
//     date: null,
//     to_acc_name: el?.type,
//     tran_amount: el?.amount,
//   }));
// };

// Create payload for sales return
export const createSalesReturnPayload = (
  customer,
  itemsList,
  footerValues,
  extraMasterData,
  selectedSerials,
  updatedServices
) => {
  // Merge service allocations
  const mergedServicesMap = {};
  // itemsList.forEach((item) => {
  //   if (Array.isArray(item.updatedServiceAllocations)) {
  //     item.updatedServiceAllocations.forEach((service) => {
  //       const key = `${service.to_acc_id}_${service.service_name}`;
  //       const amount = Number(service.updated_service_total) || 0;
  //       if (!mergedServicesMap[key]) {
  //         mergedServicesMap[key] = {
  //           to_acc_id: service.to_acc_id,
  //           service_name: service.service_name,
  //           total_service_amount: 0,
  //         };
  //       }
  //       mergedServicesMap[key].total_service_amount += amount;
  //     });
  //   }
  // });

  console.log(itemsList, "itemsListtttt");

  itemsList.forEach((item) => {
    if (Array.isArray(item.updatedServiceAllocations)) {
      item.updatedServiceAllocations.forEach((service) => {
        const toAccId = service.to_acc_id || 0;
        const amount = Number(service.updated_service_total) || 0;
        const serviceName = service.service_name || "Unknown Service";

        // skip invalid allocations
        if (toAccId === 0 || amount <= 0) return;

        const key = `${toAccId}_${serviceName}`;
        if (!mergedServicesMap[key]) {
          mergedServicesMap[key] = {
            to_acc_id: toAccId,
            service_name: serviceName,
            total_service_amount: 0,
          };
        }
        const prev = new Big(mergedServicesMap[key].total_service_amount || 0);
        mergedServicesMap[key].total_service_amount = Number(prev.plus(amount));
      });
    }
  });

  // const payServiceCart = Object.values(mergedServicesMap).map((s) => ({
  //   ...s,
  //   total_service_amount: parseFloat(s.total_service_amount.toFixed(2)),
  // }));

  const payServiceCart = Object.values(mergedServicesMap)
    .filter((s) => s.to_acc_id && s.total_service_amount > 0)
    .map((s) => ({
      ...s,
      total_service_amount: parseFloat(s.total_service_amount.toFixed(2)),
    }));

  const totalDiscount = itemsList.reduce((sum, item) => {
    const itemDiscount = new Big(item.item_discount || 0);
    const soldQty = new Big(item.sold_qty || 1);
    const returnQty = new Big(item.return_quantity || 0);

    const discountPerUnit = itemDiscount.div(soldQty);

    return sum.plus(discountPerUnit.times(returnQty));

  }, new Big(0));

  const totalTax = itemsList.reduce((sum, curr) => {
    const tax = new Big(curr.item_tax || 0);
    const soldQty = new Big(curr.sold_qty || 1);
    const returnQty = new Big(curr.return_quantity || 0);
    const taxPerUnit = tax.div(soldQty);

    return sum.plus(taxPerUnit.times(returnQty));

  }, new Big(0));

  const mappedPayCart = footerValues.payCart
    ? footerValues.payCart.map((el) => ({
      from_acc_id: el.from_acc_id || 0, // ✅ convert to integer
      from_acc_name: el.to_acc_name || el.type || "",
      acc_type_id: el.acc_type_id || "cash_in_hand",
      tran_amount: Number(el.tran_amount || el.amount || 0), // use tran_amount if exists
      date: el.date || null,
      cheque_number: el?.cheque_number || null,
      expected_bank_acc_id: el?.expected_bank_acc_id || null,
    }))
    : [];

  const totalmergedServicesMap = {};

  const allUpdatedServices = Object.values(updatedServices).flat();

  // itemCart.forEach((item) => {
  if (Array.isArray(allUpdatedServices)) {
    allUpdatedServices.forEach((service) => {
      const key = `${service.to_acc_id}_${service.service_name}`;
      const amount = Number(service.updated_service_total) || 0;

      if (!totalmergedServicesMap[key]) {
        totalmergedServicesMap[key] = {
          to_acc_id: service.to_acc_id,
          service_name: service.service_name,
          total_service_amount: 0,
        };
      }

      totalmergedServicesMap[key].total_service_amount += amount;
    });
  }
  // });

  // Convert the map to an array
  const totalPayServiceCart = Object.values(totalmergedServicesMap).map(
    (service) => ({
      ...service,
      total_service_amount: parseFloat(service.total_service_amount.toFixed(2)),
    })
  );


  let finalCreatedDate = extraMasterData.created_date;
  if (!dayjs(extraMasterData.created_date).isSame(dayjs(), "day")) {
    finalCreatedDate = getDateTimeFromSelectedDate(extraMasterData.created_date); // Merge date + current time in TZ

  } else {
    finalCreatedDate = extraMasterData.created_date; // Use now in TZ
  }


  return {
    customer: {
      acc_id: customer?.acc_id,
      acc_name: customer?.acc_name,
      institution_name: customer?.institution_name,
      country_code: customer?.country_code || "",
      contact_no: customer?.contact_no || "",
      address: customer?.address || "",
    },

    itemCart: itemsList.map((item) => ({
      sale_d_id: item.sale_d_id || null, // original sale line this return line belongs to
      warehouse_id: item.warehouse_id || 0,
      item_id: item.item_id,
      item_name: item.item_name || item.product || "",
      item_description: item.item_description || "",
      display_text: item.display_text || "",
      is_serial: item.is_serial || "no",
      available_qty: item.available_qty || item.quantity || 0,
      base_unit_name: item.base_unit_name || null,
      conversion: item.conversion || 1,
      discount_acc_id: item.discount_acc_id || 0,
      discount_acc_name: item.discount_acc_name || "",
      item_discount: item.item_discount || 0,
      item_discount_per: item.item_discount_per || 0,
      item_qty: 0,
      item_rate: Number(item.item_rate || item.rate || 0),
      item_return_rate: Number(
        item.item_return_unit_price || item.item_return_rate || 0
      ),
      item_return_unit_price: Number(
        item.item_return_unit_price || item.rate || 0
      ),
      item_tax: item.item_tax || 0,
      item_tax_per: item.item_tax_per || 0,
      serialMode: item.serial_mode,
      item_total: Number(
        new Big(item.return_quantity || 0)
          .times(item.item_return_unit_price || item.rate || 0)
          .toFixed(13)
      ),
      otherServiceTransactions: [],
      per_conversion: item.per_conversion || 1,
      per_symbol: item.unit_symbol || "",
      per_unit_id: item.per_unit_id ? item.per_unit_id : item.units[0]?.unit_id,
      per_unit_symbol: item.unit_symbol || "",
      purchase_average_rate: item?.purchase_average_rate || 0,
      // qty_display: item.qty_display || "",
      qty_display:
        item.item_qty +
        " " +
        item.unit_symbol +
        (item.conversion > 1
          ? ", " + item.retail_qty + " " + item.base_unit_name
          : ""),
      retail_qty: 0,
      return_discount: Number(new Big(item.item_discount || 0).div(item.sold_qty || 1).times(item.return_quantity || 0).toFixed(13)),
      sale_r_qty: Number(item.return_quantity || 0),
      sale_r_rate: Number(item.sale_rate || item.item_rate || 0),
      selected_batch_id: item.selected_batch_id || null,
      // serials: selectedSerials[item.item_id] || [],
      child_sscc_code: item.child_sscc_code || "",
      serials: item.selectedSerials || [],
      sold_qty: item.quantity || item.sold_qty || 0,
      tax_acc_id: item.tax_acc_id || 0,
      tax_acc_name: item.tax_acc_name || "",
      unit_name: item.unit_name || "",
      unit_symbol: item.unit_symbol || "",
      units: item.units || [],
      updatedServiceAllocations: item.updatedServiceAllocations || [],
      is_tatmeen_required: item.is_tatmeen_required === true ||
        item.is_tatmeen_required === 1 ||
        item.is_tatmeen_required === "1"
        ? 1
        : 0,
    })),
    orderId: extraMasterData.orderId || 0,
    masterData: {
      sale_r_voucher_no: extraMasterData.sale_r_voucher_no,
      is_serial: extraMasterData.is_serial || "no",
      is_cal_type: footerValues.is_call_type || "individual",
      created_date: extraMasterData.created_date
        ? formatToUtc(finalCreatedDate)
        : null,
      narration: footerValues.description || "",
      sub_total: Number(new Big(footerValues.subTotal || 0).toFixed(13)),
      total_discount_per: footerValues.total_discount_per || 0,
      total_discount: Number(new Big(totalDiscount || 0).toFixed(13)),
      total_tax_per: footerValues.total_tax_per || 0,
      total_tax: Number(new Big(totalTax || 0).toFixed(13)),
      total_transport_cost: footerValues.total_transport_cost || 0,
      total_amount: Number(new Big(footerValues.totalAmount || 0).toFixed(13)),
      sales_return_acc_id: extraMasterData.sales_return_acc_id || 0,
      sscc_code: extraMasterData.parent_sscc_code || "",

      is_tatmeen_product: extraMasterData.is_tatmeen_product,
      discount_acc_id: extraMasterData.discount_acc_id || 0,
      tax_acc_id: extraMasterData.tax_acc_id || 0,
      transport_acc_id: extraMasterData.transport_acc_id || 0,
      sale_id: extraMasterData.sale_id,
      paid_amount: Number(new Big(footerValues.paidAmount || 0).toFixed(13)),
      // acc_id: customer?.acc_id,
    },
    payCart: mappedPayCart || [],
    payServiceCart: totalPayServiceCart,
    sale_r_id: extraMasterData.sale_r_id || 0,
  };
};
